import { render, staticRenderFns } from "./EditAssignGroup.vue?vue&type=template&id=06f571c4&scoped=true&"
import script from "./EditAssignGroup.vue?vue&type=script&lang=js&"
export * from "./EditAssignGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditAssignGroup.vue?vue&type=style&index=0&id=06f571c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f571c4",
  null
  
)

export default component.exports